<script setup>
import imgCover from '@/components/conference/Ebanner_CMLA Conference_20240228-01.jpg';
import imgLookingForwardBg from '@/components/conference/lookingForwardBg.jpg';

useSeoMeta({
  title: 'Managing for Social Impact Conference',
  description: 'Sustainable and Ethical Leadership in the times of turbulence',
  ogImage: imgCover,
});

const event = useRequestEvent();
if (event) {
  if (process.env['NODE_ENV'] === 'production') {
    event.node.res.setHeader(
      'Cache-Control',
      'public, max-age=180, stale-while-revalidate',
    );
  }
}
</script>

<template>
  <NuxtLayout>
    <img :src="imgCover" style="width: 100%; height: auto" />
    <ConferenceIntroSection />
    <ConferenceAbout />
    <ConferenceSpeakers />
    <ConferenceAgenda />
    <BannerWithTitle
      class="register-now"
      :background="`url('${imgLookingForwardBg}') no-repeat center`"
      background-scrim="linear-gradient(180deg, #70A5C9 0%, rgba(0, 0, 0, 0.00) 100%);"
      style="min-height: 800px"
    >
      <h1>Looking forward to seeing you all !</h1>
      <CtaButton
        target="_blank"
        href="https://hsuhk.sharepoint.com/:b:/t/o365_CMLA-Intranet/EQcROPOy0pZInrsLvkAbRqcBtuXf6tLEzKeTmBk0Q6De9Q?e=nXpPie"
      >
        Read Newsletter
      </CtaButton>
    </BannerWithTitle>
    <ConferencePartners />
  </NuxtLayout>
</template>

<style scoped lang="scss">
.register-now {
  color: white;

  h1 {
    font-size: 40px;
    font-weight: 800;
  }

  ::v-deep(.cta) {
    background-color: transparent;
    border: 1px solid white;
    margin-top: 1.5em;
  }
}
</style>
